import { VueModule } from '@Foundation/utilities';
import LeadMagnet from './code/Scripts/components/lead-magnet.vue';

export default VueModule({
    components: {
        LeadMagnet
    }
})